import { useEffect, useState } from "react";
import { DatabaseInfo, getDatabaseInfo } from "../api/old-vine-registry-api";

export function useDatabaseInfo(): DatabaseInfo | null {
  const [databaseInfo, setDatabaseInfo] = useState<DatabaseInfo | null>(null);
  useEffect(() => {
    getDatabaseInfo().then((info) => setDatabaseInfo(info));
  }, []);
  return databaseInfo;
}
